module.exports = __webpack_public_path__ + "static/media/Dolar.2feaf25a.svg";